module.exports = __webpack_public_path__ + "static/media/3-turniry.5ab13a9b.jpg";